export default "__VITE_ASSET__D_0OSWq0__"